import { store } from "@store";
import { openDialog } from "@store/dialogs";
import { UpgradeToPublishDialog } from "./components/upgrade-to-publish-dialog";
import type { BlockedVariable } from "./plan-rules";

/** Opens the "Upgrade to publish" dialog from non-React code (hooks'
 * callbacks, error handlers). */
export const openUpgradeToPublishDialog = (
  blocked: BlockedVariable[],
  source: string,
) => {
  store.dispatch(
    openDialog({
      id: UpgradeToPublishDialog.id,
      content: UpgradeToPublishDialog,
      props: { blocked, source },
      closeOnOutsideClick: true,
    }),
  );
};
